import * as _ from 'lodash-es';

export class SessionDocument {
  scannedAt: string;
  firstName: string;
  lastName: string;
  lithocode: string;
  form: string;
  sessionId: string;
}

export class UnsubmittedSession {
  sessionId: string;
  scanIds: string[];
  results?: string[];
  userId: string;
  createdAt: number;
  submitted: boolean;
  submittedAt: string;
  site: string;
  siteName: string;
}

export class Session {
  scannedAt: string;
  fullNames: string[];
  lithocodes: string[];
  forms: string[];
  sessionId: string;
  documentCount: number;

  constructor(docs: SessionDocument[]) {
    this.scannedAt = _.first(docs).scannedAt;
    this.sessionId = _.first(docs).sessionId;
    this.fullNames = docs.map((doc) => {
      return `${doc.firstName} ${doc.lastName}`;
    });
    this.lithocodes = _.map(docs, 'lithocode');
    this.forms = _.uniq(_.map(docs, 'form'));
    this.documentCount = docs.length;
  }

  static getCollection(sessionDocs: SessionDocument[]): Session[] {
    const grouped = _.groupBy(sessionDocs, 'sessionId');
    return _.map(grouped, (docs) => new Session(docs));
  }
}
